import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import {
    SizeLink,
    TypeLink,
} from './SkyNetLink.enum'
import useStyles from './SkyNetLink.style'

export default function SkyNetLinkContent({
    onClick,
    size = SizeLink.S,
    text,
    type = TypeLink.INTERNAL,
    value,
    className,
}: Readonly<{
    text?: string,
    size?: SizeLink,
    type?: TypeLink,
    value?: string,
    onClick?: () => void,
    className?: string,
}>) {
    const {
        classes, cx,
    } = useStyles()

    return (
        <>
            <div
                className={cx(classes.link, classes.text, classes[size], className)}
                onClick={onClick}
                onKeyDown={onClick}
            >
                {text || value}
            </div>
            {
                type === TypeLink.INTERNAL_WITH_ICON && (
                    <ArrowForwardIcon className={classes[`${size}Icon`]} />
                )
            }
            {
                type === TypeLink.EXTERNAL && (
                    <OpenInNewIcon className={classes[`${size}Icon`]} />
                )
            }
        </>
    )
}
